<template>
    <div class="portlet light bordered" id="archive">
        <div v-if="isArchived">
            <div class="alert alert-danger m-3" v-text="Lang.get('messages.institution.archived')"></div>
        </div>
        <div v-else>
            <h2 v-text="Lang.get('messages.institution.archive.title')"></h2>
            <p class="help-block mb-4" v-html="Lang.get('messages.institution.archive.desc')">
            </p>

            <form method="POST">
                <input type="hidden" name="_method" value="PATCH">
                <button type="submit"
                        class="btn btn-danger"
                        @click.prevent="archive"
                        v-text="Lang.get('messages.institution.archive.submit')">
                </button>
            </form>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['institution'],

        data() {
            return { isArchived: false }
        },

        methods: {
            archive() {
                if (confirm(Lang.get('messages.institution.archive.confirm'))) {
                    axios.patch('/admin/institutions/' + this.institution.id + '/archive')
                        .then(() => this.isArchived = true);

                    flash(Lang.get('messages.institution.archive.success'));
                }
            }
        },

        created() {
            this.isArchived = this.institution.status === 'inactive';
        }
    }
</script>
